import { useRef, useState } from "react";
import { UploadCloud, X, FileText } from "lucide-react";

const ACCEPT = ".png,.jpg,.jpeg,.webp,.gif,.svg,.pdf";
const MAX = 10 * 1024 * 1024;

export const LogoDrop = ({ file, onChange, error }) => {
  const ref = useRef(null);
  const [drag, setDrag] = useState(false);
  const [localErr, setLocalErr] = useState("");

  const pick = (f) => {
    if (!f) return;
    const ext = f.name.split(".").pop().toLowerCase();
    if (!ACCEPT.includes(`.${ext}`)) return setLocalErr("الملف لازم يكون صورة أو PDF");
    if (f.size > MAX) return setLocalErr("الحجم أكبر من 10 ميجا");
    setLocalErr("");
    onChange(f);
  };

  const preview = file && file.type.startsWith("image/") ? URL.createObjectURL(file) : null;

  return (
    <div>
      <div
        onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={(e) => { e.preventDefault(); setDrag(false); pick(e.dataTransfer.files[0]); }}
        onClick={() => ref.current?.click()}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && ref.current?.click()}
        role="button"
        tabIndex={0}
        data-testid="logo-dropzone"
        className={`relative flex min-h-[150px] cursor-pointer items-center gap-5 rounded-3xl border-2 border-dashed p-5 transition-colors duration-200 ${
          drag ? "border-[var(--km-cyan)] bg-[var(--km-cyan)]/10" : error || localErr ? "border-red-400 bg-red-500/5" : "border-purple-500/40 bg-black/30 hover:border-[var(--km-pink)]"
        }`}
      >
        <input ref={ref} type="file" accept={ACCEPT} className="hidden" onChange={(e) => pick(e.target.files[0])} data-testid="logo-file-input" />
        {file ? (
          <>
            <span className="grid h-24 w-24 shrink-0 place-items-center overflow-hidden rounded-2xl bg-white/90">
              {preview ? <img src={preview} alt="معاينة اللوجو" className="h-full w-full object-contain p-2" /> : <FileText className="h-10 w-10 text-[var(--km-purple)]" />}
            </span>
            <span className="min-w-0 flex-1">
              <span className="font-head block truncate font-bold text-white" data-testid="logo-file-name">{file.name}</span>
              <span className="block text-sm text-purple-200/70">{(file.size / 1024).toFixed(0)} KB · دوس عشان تغيّره</span>
            </span>
            <button type="button" onClick={(e) => { e.stopPropagation(); onChange(null); }} aria-label="شيل الملف" data-testid="logo-remove-btn"
              className="grid h-9 w-9 place-items-center rounded-full bg-white/10 text-white hover:bg-red-500">
              <X className="h-4 w-4" />
            </button>
          </>
        ) : (
          <span className="mx-auto flex flex-col items-center text-center">
            <UploadCloud className="km-float mb-2 h-10 w-10 text-[var(--km-pink)]" />
            <span className="font-head font-bold text-white">اسحب اللوجو هنا أو دوس واختاره</span>
            <span className="text-sm text-purple-200/70">PNG, JPG, SVG, WEBP أو PDF · لحد 10 ميجا</span>
          </span>
        )}
      </div>
      {(localErr || error) && <p className="mt-2 text-sm text-red-400" data-testid="logo-error">{localErr || error}</p>}
    </div>
  );
};
